<template>
  <div id="pageRoot">
    <img
      src="/pages/img/sordovio/assets_p8/titulo.svg"
      style="width: 420px; left: 90px; top: 60px; position: absolute"
    />

    <span class="normalTheme pageInstruction" style="left: 90px; top: 150px">
      <p>Completa con una de estas expresiones.</p>
    </span>

    <p
      class="textBase basicItem01 tagDefault"
      style="width: 400px; left: 60px; top: 230px"
    >
      BUSCA EN LA ARENA.
    </p>
    <p
      class="textBase basicItem01 tagDefault"
      style="width: 400px; left: 550px; top: 230px"
    >
      LO TIENE ESCONIDO.
    </p>
    <p
      class="textBase basicItem01 tagDefault"
      style="width: 400px; left: 60px; top: 320px"
    >
      LLORA EN LA ORILLA.
    </p>
    <p
      class="textBase basicItem01 tagDefault"
      style="width: 400px; left: 550px; top: 320px"
    >
      ESCRIBIÓ EN LA ARENA.
    </p>

    <p
      class="textBase"
      style="top: 480px; left: 80px; font-size: 32px; position: absolute"
    >
      EL GUITARRERO
    </p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <img
      style="width: 180px; top: 420px; left: 780px"
      class="pageElement basicItem01"
      src="/pages/img/sordovio/assets_p8/guitarrero.svg"
    />

    <p
      class="textBase"
      style="top: 650px; left: 80px; font-size: 32px; position: absolute"
    >
      EL TERITO REAL
    </p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <img
      style="width: 140px; top: 570px; left: 780px"
      class="pageElement basicItem01"
      src="/pages/img/sordovio/assets_p8/tero.svg"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 57px;
  top: 57px;
}
#inputField01 {
  position: absolute;
  width: 383px;
  left: 330px;
  top: 460px;
}
#inputField02 {
  position: absolute;
  width: 383px;
  left: 330px;
  top: 633px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 19.mp4",
        "vio/Video 20.mp4",
        "vio/Video 21.mp4",
        "vio/Video 22.mp4",
        "vio/Video 23.mp4",
        "vio/Video 24.mp4",
        "vio/Video 25c.mp4",
      ],
    };
  },
};
</script>